import {createSelector} from "@reduxjs/toolkit";
import {ReducerStatuses} from "services/utils/utils";
import {initialState} from "./reducer";

const baseState = state => state.people.search;
const baseData = createSelector([baseState], state => state.data);

export const peopleSearchFilters = createSelector([baseState], (state) => {
    return state.filters;
});
export const peopleSearchFiltersActive = createSelector([baseState], (state) => {
    return JSON.stringify(state.filters) !== JSON.stringify(initialState.filters);
});

export const peopleSearchData = createSelector([baseData], (data) => {
    return {
        companies: Object.values(data.companies).sort((a, b) => a.index - b.index),
        profiles: Object.values(data.profiles).sort((a, b) => a.index - b.index)
    }
});

export const peopleSearchCurrentPage = createSelector([baseState], (state) => {
    return state.current_page;
});
export const peopleSearchLoading = createSelector([baseState, peopleSearchCurrentPage], (state, page) => {
    return state.status === ReducerStatuses.LOADING && page === 1
});
export const peopleSearchHasNextProfiles = createSelector([baseState], (state) => {
    return !!state.metadata.profilesHasNext;
});
export const peopleSearchHasNextCompanies = createSelector([baseState], (state) => {
    return !!state.metadata.companiesHasNext;
});
export const peopleSearchNextLoading = createSelector([baseState, peopleSearchCurrentPage], (state, page) => {
    return state.status === ReducerStatuses.LOADING  && page !== 1
});
export const peopleSearchErrorSelector = createSelector([baseState], (state) => {
    return {
        inError: state.status === ReducerStatuses.ERROR,
        error: state.error
    }
});